// extracted by mini-css-extract-plugin
export default {"mydiv":"header_mydiv__eL+B3","container":"header_container__AzWgZ","titleContainer":"header_titleContainer__Kh65h","span":"header_span__KQM8T","navList":"header_navList__FViQ0"};